import { articleCSS } from '@common/cssComponents';

import Meta from '@components/Meta';
import { ShareArticleButtons } from '@components/Resources/Article/ShareArticleButtons';
import { SuccessStorySuggestions } from '@components/SuccessStorySuggestions';
import { Hero } from '@components/Hero/Hero';
import { SignPost } from '@common/SignPost';
import { ReferencesRibbon } from '@common/ReferencesRibbon';
import { Footer } from '@components/Footer/Footer';

import { getMagazineFeaturedImageSize } from '@nextUtils/guidesUtils';

import { ArticleProps } from '@nextTypes/guides';

const StoryPage = ({
  category,
  categorySlug,
  contentHTML,
  featuredImageSizes,
  metaDescription,
  sameCategoryPosts,
  seoTitle,
  slug,
  title,
  featuredImageUrl,
}: ArticleProps): JSX.Element => {
  const contentHTMLWithExtraCTA = contentHTML;

  const canonicalSlug =
    category === 'Local' // For Local use one forward slash in the slug link, e.g. bristol/weight-watchers
      ? slug.replace('-', '/')
      : slug;

  const relativeCanonicalURL = `${categorySlug}/${canonicalSlug}`;

  const absoluteCanonicalURL = `https://www.secondnature.io${relativeCanonicalURL}`;

  return (
    <>
      <Meta
        title={seoTitle || title}
        metaDescription={metaDescription}
        ogImageUrl={getMagazineFeaturedImageSize(featuredImageSizes).sourceUrl}
        /* Magazine is fixed 710x375 size */
        ogImageWidth={710}
        ogImageHeight={375}
        relativeCanonicalURL={relativeCanonicalURL}
      />
      <Hero
        title={<span className="text-blue">{title}</span>}
        description={<span className="text-blue">{metaDescription}</span>}
        color="bg-purple"
        altText={title}
        image={featuredImageUrl}
        isColourBlockImage
        priority
      />
      <div className="px-3 pb-[56px] lg:px-0 lg:pb-[125px]">
        <div className="m-auto max-w-[870px]">
          <div
            // article-content is set globally to allow the styling of the article content to be overridden
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className="article-content font-cera text-[16px] font-normal leading-[26px] tracking-[-0.22px] text-blue md:text-[18px] md:leading-[30px]"
            dangerouslySetInnerHTML={{ __html: contentHTMLWithExtraCTA }}
          />
          <ShareArticleButtons articleUrl={absoluteCanonicalURL} />
        </div>
      </div>
      <SuccessStorySuggestions
        currentSlug={slug}
        posts={sameCategoryPosts.edges}
      />
      <SignPost version="A" />
      <ReferencesRibbon />
      <Footer />
      <style jsx>{articleCSS}</style>
    </>
  );
};

export default StoryPage;
